import { render, staticRenderFns } from "./donutHandler.vue?vue&type=template&id=d4de88b6&"
import script from "./donutHandler.vue?vue&type=script&lang=js&"
export * from "./donutHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports